import { render, staticRenderFns } from "./TarifaDetalleTarifario.vue?vue&type=template&id=5aa3aab2"
import script from "./TarifaDetalleTarifario.vue?vue&type=script&lang=js"
export * from "./TarifaDetalleTarifario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports